/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  //--->Slider
  $("#appearance7").roundSlider({
    radius: 190,
    width: 15,
    handleSize: "+18",
    handleShape: "round",
    sliderType: "default",
    value: 0,
    startAngle: 90,

    circleShape: "full"

  });

  $("#appearance8").roundSlider({
    radius: 140,
    width: 3,
    handleSize: "+16",
    handleShape: "round",
    sliderType: "default",
    value: 0,
    startAngle: 90,

    circleShape: "full"

  });

  var _item_active =  $("a[data-radius=0]");

  $("#appearance8").roundSlider("disable");
  $("#appearance7").on("change", function (e) {
    $("#appearance8").roundSlider("setValue",e.value);
  });

  $("a[data-radius]").on("hover",function(){

    var r_min = parseInt($(this).data("radius-min"));


    var r_radius = parseInt($(this).data("real-radius"));
    $("#appearance7").roundSlider("setValue", (r_radius));
    $("#appearance8").roundSlider("setValue", (r_radius));
    _item_active.removeClass("active");

    $("a[data-radius="+(r_min === 95 ? '0': (r_min+ 5))+"]").addClass("active");
    _item_active = $("a[data-radius="+(r_min === 95 ? '0': (r_min+ 5))+"]");
  });

  $("#appearance7").on("drag", function (e) {
    var _R = e.value;
    console.log(_R);
    _item_active.removeClass("active");

    if(_R >= 95 && _R <= 100 ||_R >= 0 && _R <= 4)
    {
      $("a[data-radius=0]").addClass("active");
      _item_active =  $("a[data-radius=0]");
    }
    if(_R >= 5 && _R <= 14 )
    {
      $("a[data-radius=10]").addClass("active");
      _item_active =  $("a[data-radius= 10]");
    }
    if(_R >= 15 && _R <= 24 )
    {
      $("a[data-radius=20]").addClass("active");
      _item_active =  $("a[data-radius= 20]");
    }
    if(_R >= 25 && _R <= 34 )
    {
      $("a[data-radius=30]").addClass("active");
      _item_active =  $("a[data-radius= 30]");
    }
    if(_R >= 35 && _R <= 44 )
    {
      $("a[data-radius=40]").addClass("active");
      _item_active =  $("a[data-radius= 40]");
    }
    if(_R >= 55 && _R <= 64 )
    {
      $("a[data-radius=60]").addClass("active");
      _item_active =  $("a[data-radius= 60]");
    }
    if(_R >= 65 && _R <= 74 )
    {
      $("a[data-radius=70]").addClass("active");
      _item_active =  $("a[data-radius= 70]");
    }
    if(_R >= 75 && _R <= 84 )
    {
      $("a[data-radius=80]").addClass("active");
      _item_active =  $("a[data-radius= 80]");
    }
    if(_R >= 85 && _R <= 94 )
    {
      $("a[data-radius=90]").addClass("active");
      _item_active =  $("a[data-radius= 90]");
    }

    $("#appearance8").roundSlider("drag",_R);
  });

  //mouse scroll
  $(".mouse-scroll").on("click",function(e){
    e.preventDefault();
    $('html,body').animate({ scrollTop: $(".whoweare").offset().top},"slow");
  });


  //set hr element
  $(".navbar-nav").append("<hr>");
  $(".staff-list .item .contain").mouseover(function(){

  });

  //tecnologies

  $(".list-intelligens span.num").each(function(){
    var max = parseInt($(this).data('percent'));
    var elem = $(this);
    setTimeout(function(){
      elem.animateNumber(
          {
            number: max,
            easing: 'easeInQuad'

          },
          3500
      );

    },1000);

  });
  $(".list-intelligens .item .tile").each(function(){
    var t = $(this);
    setTimeout(function(){
      t.animate({
        opacity: 1
      },3500);

    },1000);

  });


  $('.more-projects:not(.loading)').live('click',function(e){
    e.preventDefault();
    var $load_more_btn = $(this);
    var post_type = 'post'; // this is optional and can be set from anywhere, stored in mockup etc...
    var offset = $('#blog-list .item').length;
    var nonce = $load_more_btn.attr('data-nonce');
    $.ajax({
      type : "post",
      context: this,
      dataType : "json",
      url : headJS.ajaxurl,
      data : {action: "load_more", offset:offset, nonce:nonce, post_type:post_type, posts_per_page:headJS.posts_per_page},
      beforeSend: function(data) {
        // here u can do some loading animation...
        $load_more_btn.addClass('loading');// good for styling and also to prevent ajax calls before content is loaded by adding loading class
      },
      success: function(response) {
        if (response.have_posts){//if have posts:
          $load_more_btn.removeClass('loading');
          var $newElems = $(response.html.replace(/(\r\n|\n|\r)/gm, ''));// here removing extra breaklines and spaces
          $('#blog-list').append($newElems);
        } else {
          //end of posts (no posts found)
          $('#text-load-views').html("Nessun altra News da mostrare");
          $load_more_btn.addClass('hidden'); // change buttom styles if no more posts
        }
      }
    });
  });


})(jQuery); // Fully reference jQuery after this point.


